<template>
  <div>
      <v-alert dismissible type="error" v-if="unknownUser" transition="fade-transition">
        <strong>{{unknownUser}} is not a valid account.</strong> <br> Please try a different email address.
      </v-alert>

    <v-card outlined>
      <div class="pa-5">
        <v-row>
          <template v-if="!signingIn">
          <v-col cols="12" class="text-center">
            <div class="d-flex justify-center mb-5">
              <div class="text-center">
                <v-row align="center" class="no-gutters">
                  <v-col class="text-center" cols="3">
                    <v-icon class="logo-icon" color="light-blue">mdi-home</v-icon>
                  </v-col>
                  <v-col class="text-left logo-text">
                    <div class="pl-5">
                      <span class="d-block">Rental Property</span>
                      <span>Manager</span>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-col>
            <v-col cols="12" class="text-center py-0">
              <div class="d-block pb-4">
                Sign in with your Google account to continue.
              </div>
            </v-col>
            <v-col class="text-center py-0" cols="12">
              <v-btn elevation="0" @click="login" dark color="light-blue">
                <v-icon small class="mr-1">mdi-google</v-icon>
                Sign In
              </v-btn>
            </v-col>
          </template>
          <template v-else>
            <v-col class="text-center py-0" cols="12">
              <h3>Signing In...</h3>
              <div class="my-5">
                <v-progress-circular color="light-blue" indeterminate></v-progress-circular>
              </div>
            </v-col>
          </template>
        </v-row>
      </div>
    </v-card>
  </div>

</template>

<script>
  import Firebase from '../firebase.js';
  import { mapGetters } from "vuex";

  export default {
    name: "GoogleLogin",

    props: {},
    data: () => ({}),
    computed: {
      ...mapGetters([
        'unknownUser',
        'signingIn'
      ]),
    },
      methods: {
      login() {
        Firebase.login()
      },
    }

  }
</script>

<style scoped>

</style>